// Picks "#000" or "#fff" depending on the perceived luminance of the
// background colour, so light fills (yellows, light blues...) stop
// writing white on top. Uses the YIQ contrast heuristic
// (https://www.w3.org/TR/AERT/#color-contrast) which is good enough
// for arbitrary user-chosen team-group colours.

export function contrastColor(hex: string | undefined | null): string {
    if (!hex) return '#fff';
    let cleaned = hex.trim().replace('#', '');
    if (cleaned.length === 3) {
        cleaned = cleaned.split('').map(c => c + c).join('');
    }
    if (cleaned.length !== 6 || /[^0-9a-fA-F]/.test(cleaned)) return '#fff';
    const r = parseInt(cleaned.slice(0, 2), 16);
    const g = parseInt(cleaned.slice(2, 4), 16);
    const b = parseInt(cleaned.slice(4, 6), 16);
    const yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 140 ? '#000' : '#fff';
}
